import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const DetalhesCurso = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [curso, setCurso] = useState(null);
  const { parametros } = useCliente();

  useEffect(() => {
    const fetchCurso = async () => {
      try {
        const response = await axios.get(`/api/cursos/${id}`);
        setCurso(response.data);
      } catch (error) {
        console.error("Erro ao buscar curso:", error);
      }
    };

    fetchCurso();
  }, [id]);

  const handleEditar = () => {
    navigate(`/editar-curso/${id}`);
  };

  const handleExcluir = async () => {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este curso?");
    if (confirmacao) {
      try {
        const usuario_id = localStorage.getItem("user_id");
        await axios.delete(`/api/cursos/${id}?usuario_id=${usuario_id}`);
        alert("Curso excluído com sucesso!");
        navigate("/cursos");
      } catch (error) {
        console.error("Erro ao excluir curso:", error);
        alert("Erro ao excluir curso.");
      }
    }
  };
  

  const handleVoltar = () => {
    navigate("/cursos");
  };

  if (!curso) {
    return <div>Carregando detalhes do curso...</div>;
  }

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Detalhes do Curso</h2>

      <div className="form-group">
        <label>Código do Curso:</label>
        <span>{curso.codigo}</span>
      </div>

      <div className="form-group">
        <label>Nome do Curso:</label>
        <span>{curso.nome}</span>
      </div>

 <div className="linha-horizontal">
  <div className="coluna">
    <div style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>Modalidade:</div>
    <span>{curso.modalidade}</span>
  </div>
  <div className="coluna">
    <div style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>Nível:</div>
    <span>{curso.nivel}</span>
  </div>
  <div className="coluna">
    <div style={{ fontWeight: "bold", marginBottom: "0.25rem" }}>Coordenador:</div>
    <span>{curso.coordenador}</span>
  </div>
</div>



      <div className="form-group">
        <label>Disciplinas Vinculadas:</label>
        {curso.disciplinas && curso.disciplinas.length > 0 ? (
          <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
            <thead
              style={{
                backgroundColor: parametros?.cor_cabecalho || "#156082",
                color: "white"
              }}
            >
              <tr>
                <th style={{ textAlign: "left" }}>Código</th>
                <th style={{ textAlign: "left" }}>Nome</th>
              </tr>
            </thead>
            <tbody>
              {curso.disciplinas.map((disciplina, index) => (
                <tr key={index}>
                  <td>{disciplina.codigo}</td>
                  <td>{disciplina.nome}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <span>Nenhuma disciplina vinculada.</span>
        )}
      </div>

      <div className="form-actions">
        <button className="btn btn-primary" onClick={handleEditar}>Editar</button>
        {localStorage.getItem("tipo") !== "coordenador" && (
        <button className="btn btn-danger" onClick={handleExcluir}>Excluir Curso</button>
      )}
        <button className="btn btn-secondary" onClick={handleVoltar}>Voltar</button>
      </div>
    </div>
  );
};

export default DetalhesCurso;
